import { takeLatest, put, all, call } from "redux-saga/effects";
import GeneralActionTypes from "./general.types";
import { encryptData } from "../_common/enode-decode";
import {
  fetchCountryStateList,
  fetchStateCityList,
  getAllCountryList,
} from "./general.service";
import {
  fetchCountryListFailure,
  fetchCountryListResponseChanged,
  fetchCountryListSuccess,
  fetchCountryStateListFailure,
  fetchCountryStateListResponseChanged,
  fetchCountryStateListSuccess,
  fetchStateCityListFailure,
  fetchStateCityListResponseChanged,
  fetchStateCityListSuccess,
} from "./general.action";

/** *********************  START FETCH COUNTRY LIST  ******************** */
export function* fetchCountryListData() {
  try {
    const jsonData = {
      country: "",
    };
    const countryData = encryptData(jsonData, "GetCountryListKey");
    // @ts-ignore
    const responseData = yield call(getAllCountryList, countryData);
    if (responseData.data.statusCode === "500") {
      yield put(fetchCountryListFailure(responseData.data));
    } else {
      yield put(fetchCountryListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchCountryListFailure(error));
  }
}

export function* resetFetchCountryList() {
  yield put(fetchCountryListResponseChanged());
}

export function* onGetCountryList() {
  yield takeLatest(
    GeneralActionTypes.FETCH_COUNTRY_LIST_START,
    fetchCountryListData,
  );
}

export function* onResetCountryResponseStart() {
  yield takeLatest(
    GeneralActionTypes.FETCH_COUNTRY_LIST_RESPONSE_RESET,
    resetFetchCountryList,
  );
}
/** *********************  END FETCH  COUNTRY LIST  ******************** */

/** *********************  START FETCH COUNTRY  STATE LIST  ******************** */
export function* fetchCountryStateListData({ payload }: any) {
  try {
    const jsonData = {
      CountryID: payload.countryID,
      InstanceName: payload.InstanceName,
    };
    const countryData = encryptData(jsonData, "CountryStateListGetKey");
    // @ts-ignore
    const responseData = yield call(fetchCountryStateList, countryData);
    if (responseData.data.statusCode === "500") {
      yield put(fetchCountryStateListFailure(responseData.data));
    } else {
      yield put(fetchCountryStateListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchCountryStateListFailure(error));
  }
}

export function* resetFetchCountryStateList() {
  yield put(fetchCountryStateListResponseChanged());
}

export function* onFetchCountryStateList() {
  yield takeLatest(
    GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_START,
    fetchCountryStateListData,
  );
}

export function* onResetFetchCountryStateResponseStart() {
  yield takeLatest(
    GeneralActionTypes.FETCH_COUNTRY_LIST_STATE_RESPONSE_RESET,
    resetFetchCountryStateList,
  );
}
/** *********************  END FETCH  COUNTRY  STATE LIST  ******************** */

/** *********************  START FETCH STATE CITY LIST  ******************** */
export function* fetchStateCityListData({ payload }: any) {
  try {
    const jsonData = {
      StateID: payload.stateID,
    };
    const countryData = encryptData(jsonData, "StateCityListGetKey");
    // @ts-ignore
    const responseData = yield call(fetchStateCityList, countryData);
    if (responseData.data.statusCode === "500") {
      yield put(fetchStateCityListFailure(responseData.data));
    } else {
      yield put(fetchStateCityListSuccess(responseData.data));
    }
  } catch (error) {
    yield put(fetchStateCityListFailure(error));
  }
}

export function* resetFetchStateCityList() {
  yield put(fetchStateCityListResponseChanged());
}

export function* onFetchStateCityList() {
  yield takeLatest(
    GeneralActionTypes.FETCH_STATE_CITY_LIST_START,
    fetchStateCityListData,
  );
}

export function* onResetFetchStateCityResponseStart() {
  yield takeLatest(
    GeneralActionTypes.FETCH_STATE_CITY_LIST_RESPONSE_RESET,
    resetFetchStateCityList,
  );
}
/** *********************  END FETCH STATE CITY LIST  ******************** */

export function* generalSaga() {
  yield all([
    call(onResetCountryResponseStart),
    call(onGetCountryList),
    call(onFetchCountryStateList),
    call(onResetFetchCountryStateResponseStart),
    call(onFetchStateCityList),
    call(onResetFetchStateCityResponseStart),
  ]);
}
